import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const tid = localStorage.getItem("active_tenant_id");
  if (tid) config.headers["X-Tenant-Id"] = tid;
  return config;
});

export default api;
export { API };
